@if (mapOptions) {
  <div
    [style.height]="mapHeight()"
    class="map-container"
    leaflet
    leafletPing
    [leafletPingOptions]="leafletPingOptions"
    (leafletPingObserver)="setLeafletPingObserver($event)"
    [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)"
  ></div>
}

@if (loading()) {
  <bi-spinner [centerInParent]="true" [hasBackground]="true" spinnerSize="large" [fixedPosition]="false" />
}
